<div class="container-fluid default-block-padding-top">
  <div class="row">
    <div class="col-12 text-end">
  @if(data.pdf){
      <a [href]="data.pdf.url" class="btn btn-light-blue mb-3 me-3" target="_blank"
        >Route PDF <i class="fa-duotone fa-solid fa-circle-arrow-down"></i></a
      >
      }
      @if(data.link){
      <a
        [href]="data.link?.url"
        class="btn btn-light mb-3"
        [attr.target]="data.link.openInNewTab ? '_blank' : null"
        >{{ data.link?.text }} <i class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"></i></a
      >
      } 
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 order-lg-2 text-end img-col">
    
       @if(data.image){
      <img
        [src]="data.image?.url"
        class="img-fluid default-border-radius mt-3"
        [alt]="data.image?.altText"
      />
      }
    </div>
    <div class="col-lg-6 order-lg-1">
      <div class="content" [innerHTML]="data.content | bypassSecurity"></div>

      <div class="row info-row">
        <div class="col-4">
          <label>Start</label>
        </div>
        <div class="col-8">
          {{ data.start }}
        </div>
        <div class="col-12">
          <div class="border-box"></div>
        </div>
      </div>
      <div class="row info-row">
        <div class="col-4">
          <label>Finish</label>
        </div>
        <div class="col-8">
          {{ data.finish }}
        </div>
        <div class="col-12">
          <div class="border-box"></div>
        </div>
      </div>
      <div class="row info-row">
        <div class="col-4">
          <label>Prijs</label>
        </div>
        <div class="col-8">
          <strong
            >Leden:
            {{
              data.memberPrice | currency : "EUR" : "symbol" : "1.2-2"
            }}</strong
          >
          |
          <strong
            >niet-leden:
            {{
              data.nonMemberPrice | currency : "EUR" : "symbol" : "1.2-2"
            }}</strong
          >
        </div>
      </div>
    </div>
  </div>
</div>
